document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const price = form?.querySelector('[data-variant-price]');
  const button = form?.querySelector('[type="submit"]');

  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.disabled;
    button.querySelector('[data-button-label]').textContent = option.disabled ? '売り切れ' : 'カートに追加';
  }
});
